import { Typography } from "@mui/material"

const CamposObligatoriosLeyenda = () => {

    return <Typography>Los campos marcados con <b style={{ fontSize: 30, color: "red" }}>*</b> son requeridos</Typography>
}

export default  CamposObligatoriosLeyenda